
import React from "react";
import ReceitasChart from "./ReceitasChart";
import DespesasChart from "./DespesasChart";
import ComparativoChart from "./ComparativoChart";

const RelatoriosContent = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 animate-in fade-in-50">
      <ReceitasChart />
      <DespesasChart />
      <ComparativoChart />
    </div>
  );
};

export default RelatoriosContent;
